var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-box",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"scroll-fixed"}),_c('div',{staticClass:"scroll-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }